export const MODAL_TITLE = 'Solicitação de férias';

export const DECISION_LEGEND = 'Decisão sobre o período';
export const APPROVE_LABEL = 'Validar férias';
export const APPROVE_HINT = 'Agenda o período e libera o envio do aviso.';
export const REJECT_LABEL = 'Reprovar';
export const REJECT_HINT = 'Encerra a solicitação; o colaborador pode enviar outra.';

export const NOTE_LABEL_APPROVE = 'Observação (opcional)';
export const NOTE_LABEL_REJECT = 'Motivo da reprovação';
export const NOTE_PLACEHOLDER_APPROVE = 'Ex.: aviso de férias já preparado para assinatura.';
export const NOTE_PLACEHOLDER_REJECT =
    'Ex.: período ultrapassa o limite para aprovar; propor início até 30/09.';

export const SELL_LEGEND = 'Decisão sobre o abono pecuniário';
export const SELL_HINT =
    'O colaborador pediu para vender 1/3 das férias. A decisão é independente da do período (art. 143).';
export const SELL_APPROVE_LABEL = 'Aprovar abono';
export const SELL_REJECT_LABEL = 'Reprovar abono';

export const CONFIRM_LABEL = 'Confirmar decisão';
export const SUBMITTING_LABEL = 'Registrando...';
export const CANCEL_LABEL = 'Cancelar';
export const CLOSE_LABEL = 'Fechar';

export const NOT_DECIDABLE_HINT =
    'Esta solicitação não está aguardando o DP. Você está vendo o resumo do que foi pedido.';

export const OWN_REQUEST_WARNING =
    'Esta solicitação é sua. A decisão precisa ser de outra pessoa do DP.';
